import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';

const CustomDataTable = ({
  rows = [],
  columns = [],
  pageSize = 10,
  pageSizeOptions = [10, 50, 100],
  checkboxSelection = false,
  filterModel,
  setFilterModel,
  enableRowHover,
  ...props
}) => {

  const paginationModel = { page: 0, pageSize };

  return (
    <Paper sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={pageSizeOptions}
        checkboxSelection={checkboxSelection}
        columnHeaderHeight={46}
        rowHeight={44}
        hideFooterSelectedRowCount
        filterModel={filterModel}
        onFilterModelChange={(model) => {
          setFilterModel(model);
        }}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#F8F8F8',
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#F8F8F8',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#111',
            fontSize: '14px',
            fontWeight: 500,
          },
          '& .MuiDataGrid-cell': {
            color: '#333',
            fontSize: '13px',
            fontWeight: 400,
          },
          '& ::-webkit-scrollbar': {
            width: '8px',
            height: '8px'
          },
          '& ::-webkit-scrollbar-thumb': {
            backgroundColor: '#999',
            borderRadius: '12px',
            cursor: 'pointer'
          },
          '& ::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1'
          },
          ...(enableRowHover && {
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
              cursor: 'pointer',
            },
          }),
        }}
        {...props}
      />
    </Paper>
  );
};

export default CustomDataTable;